<bz-button variant="tertiary"
           [disabled]="isDisabled"
           [ariaLabel]="'Fullscreen' | translate"
           (clicked)="onToggle()">
  <bz-icon class="primary-300" [icon]="isShow ? icons.maximize : icons.minimize"></bz-icon>
</bz-button>
